<div class="flex flex-col items-center px-4 py-8 xs:px-0">
  <div class="flex w-full flex-col gap-6 xs:w-[448px]">
    <!-- All set! card -->
    <div class="flex flex-col items-center gap-3 rounded-3xl bg-gradient-to-br from-[#f8fcff] to-[#f0f8ff] px-8 py-6 text-center">
      <svg-icon key="px-96-success" size="3xl" class="self-center"></svg-icon>
      <div class="flex flex-col gap-1">
        <h1 class="typo-h1 text-text-primary">
          {{ 'baa_request_list_all_set_title' | translate }}
        </h1>
        <p class="typo-h4-light font-extralight text-text-secondary">
          {{ practiceName() }}
        </p>
        <p class="typo-h4-light font-extralight text-text-secondary">
          {{ 'baa_request_list_all_set_description' | translate }}
        </p>
        @if (notifiedRequesterName(); as requesterName) {
          <p class="typo-h4-light mt-1 font-extralight text-text-secondary">
            {{ 'baa_request_list_all_set_notified_description' | translate: { input1: requesterName } }}
          </p>
        }
      </div>
    </div>

    <!-- Pending requests section -->
    <lib-baa-request-list-items
      [requests]="service.otherRequestsSignal()"
      [isActionLoading]="service.isActionLoadingSignal()"
      (approve)="service.approveRequest($event)"
      (deny)="service.denyRequest($event)"
    />

    <!-- Download for iOS section -->
    <div class="flex flex-col gap-3 rounded-3xl border border-text-extra-light bg-background-white p-4">
      <div class="flex flex-col gap-1">
        <h3 class="typo-h4-semibold text-text-primary">{{ 'baa_request_list_download_title' | translate }}</h3>
        <p class="typo-h5-light font-extralight text-text-secondary">{{ 'baa_request_list_download_subtitle' | translate }}</p>
      </div>
      <a [href]="iosAppUrl" target="_blank" rel="noopener noreferrer" class="btn-primary-big flex w-full items-center justify-center">
        <svg-icon key="px-24-apple" size="md" class="text-white"></svg-icon>
        {{ 'baa_request_list_download_cta' | translate }}
      </a>
    </div>
  </div>
</div>
